<template>
    <div class="section pt-1 mt-2" v-if="report_permission">
        <div class="wallet-card mt-1">
            <div class="wallet-footer wallet-footer-user">
                <div class="item">
                    <router-link :to="'/org/'+$route.params.sub_level+'/' + $route.params.id +'/org-excecutive-report'">
                        <a href="javascript:void(0)">
                            <div class="row">
                                <div class="icon-wrapper col-2">
                                    <ion-icon name="receipt-outline"></ion-icon>
                                </div>
                                <strong class="add-member-btn mal-text col-10">
                                {{
                                    $t('election_report', {
                                    level:
                                        $route.params.sub_level == 2 ? $t('district') :
                                        $route.params.sub_level == 1 ? $t('state') :
                                        $route.params.sub_level == 4 ? $t('unit') :
                                        $t('zone')
                                    })
                                }}
                                </strong>
                            </div>
                        </a>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
    <div class="section pt-1 mt-2">
        <div class="wallet-card">
            <div class="wallet-footer">
                <ul class="nav nav-tabs lined" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" data-bs-toggle="tab" href="javascript:void(0)" role="tab" @click="getAdminList(1)">
                                    {{ $t('wisdom') }}
                            </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="javascript:void(0)" role="tab" @click="getAdminList(2)">
                                    {{ $t('youth') }}
                                </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="javascript:void(0)" role="tab" @click="getAdminList(3)">
                                    {{ $t('students') }}
                                </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="javascript:void(0)" role="tab" @click="getAdminList(4)">
                                    {{ $t('women') }}
                                </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="javascript:void(0)" role="tab" @click="getAdminList(6)">
                                    {{ $t('girls') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="javascript:void(0)" role="tab" @click="getAdminList(5)">
                                    {{ $t('balavedi') }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <!-- AddAdminModel -->
    <div class="modal fade action-sheet" id="addAdminModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-if="!add_admin">{{ $t('edit_executive_member') }}</h5>
                    <h5 class="modal-title" v-if="add_admin">{{ $t('add_executive_member') }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <Form @submit="addAdmin" :validation-schema="schema">
                            <div class="form-group basic">
                                <label class="label" for="wing">{{ $t('wing') }}</label>
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <Field as="select" :disabled="true" class="form-control custom-select" v-model="wing" name="wing" id="select4" @change="getDepartments($event.target.value,true)">
                                            <option selected>{{ $t('select_wing') }}</option>
                                            <option value="1">{{ $t('wisdom') }}</option>
                                            <option value="2">{{ $t('youth') }}</option>
                                            <option value="3">{{ $t('students') }}</option>
                                            <option value="4">{{ $t('women') }}</option>
                                            <option value="6">{{ $t('girls') }}</option>
                                            <option value="5">{{ $t('balavedi') }}</option>
                                        </Field>
                                    </div>
                                </div>
                                <ErrorMessage name="wing" class="error-feedback" />
                            </div>
                            <div class="form-group row boxed typehead-div">
                                <div class="input-wrapper col-12">
                                    <label class="label" for="text4b">{{ $t('member') }}</label>
                                    <!-- <Field type="text" class="form-control" name="member" id="text4b"
                                                v-if="member && !member_edit" :readonly="true" v-model="member.text" /> -->
    
                                    <v-select label="text" :filterable="true" :disabled="disable_member_form" v-model="member" :value="member" :options="member_list" @input="getTextList($event.target.value,wing)">
                                        <template>
                                            <div class="d-center">
                                                {{ $t('search') }}
                                            </div>
                                        </template>

<template>
    <div class="d-center">
        {{ member.name }}
    </div>
</template>
                                    </v-select>
                                    <ErrorMessage name="member" class="error-feedback" />
                                </div>
                                <!-- <button type="button" class="btn btn-icon btn-primary me-1 col-2 edit-btn"
                                    @click="editBtn()">
                                    <ion-icon name="create-outline"></ion-icon>
                                </button> -->
                                <div class="input-info" v-if="member">{{ $t('mobile_number') }} :{{member.country_code}} {{member.mobile}}
                                </div>
                            </div>
                            <div class="form-group basic">
                                <label class="label" for="designation">{{ $t('designation') }}</label>
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <Field as="select" class="form-control custom-select" v-model="designation"
                                            name="designation" id="select4">
                                            <option v-for="item in ($route.params.sub_level == 1?state_designations: wing != 5?designations:balavedi_designations)"
                                                v-bind:key="item.id" v-bind:value="item.id">
                                                {{$i18n.locale == 'en' ? item.value : item.value_mal}}
                                            </option>
                                        </Field>
                                    </div>
                                </div>
                                <ErrorMessage name="designation" class="error-feedback" />
                            </div>
                            <div class="form-group boxed" v-if="wing != 5">
                                <div class="input-wrapper">
                                    <label class="label mal-text" for="text4b">{{ $t('wings') }}</label>
                                    <div class="row">
                                        <div class="form-check mb-1 col-12" v-for="(item, index) in department_list"
                                            :value="item.id" v-bind:key="item.id"
                                            :set="id = 'customCheckb2' + (index + 1)">
                                            <input type="checkbox" class="form-check-input" v-bind:id="id"
                                                v-bind:value="{id : item.id, text: $i18n.locale == 'en' ? item.name : item.name_mal}" v-model="department">
                                            <label class="form-check-label mal-tex" v-bind:for="id">{{ $i18n.locale == 'en' ? item.name : item.name_mal }}</label>
                                        </div>
                                        <ErrorMessage name="department" class="error-feedback" />
                                    </div>
                                </div>
                            </div>

                            <div class="form-group" v-if="message">
                                <div v-if="message" class="error-feedback">
                                    {{ message }}
                                </div>
                            </div>

                            <div class="form-group basic">
                                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="loading"
                                    v-if="editable || add_admin">
                                    <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                    <span>{{ $t('save') }}</span></button>
                                <button type="button" class="btn btn-primary btn-block btn-lg"
                                    v-if="!editable && !add_admin" @click="closeAddAdminModel">{{ $t('close') }}</button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- DeleteMemberModel -->
    <div class="modal fade action-sheet" id="excCountModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('executive_count') }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">

                        <div class="form-group" v-if="exc_count">
                            <div v-if="exc_count" class="error-feedback">
                                {{ message_delete }}
                            </div>
                        </div>
                        <div class="form-group basic">
                            <label class="label" for="Name"><span class="mal-text">{{ $t('executive_count_selected') }}</span></label>
                            <div class="form-group boxed">
                                <Field name="count" type="number" class="form-control" v-model="exc_count"
                                    :placeholder="$t('enter_executive_count')" autocomplete="off" />
                            </div>
                        </div>
                        <div class="form-group" v-if="message">
                            <div v-if="message" class="error-feedback">
                                {{ message }}
                            </div>
                        </div>
                        <div class="form-group basic">
                            <button type="button" @click="countSave()" class="btn btn-primary btn-block btn-lg"
                                :disabled="loading">
                                <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                <span>{{ $t('save') }}</span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- * AddMemberModel -->

    <!-- Election Minutes Upload Modal -->
    <div class="modal fade action-sheet" id="electionMinutesModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('election_minutes_upload') }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        
                        <div class="form-group basic">
                            <label class="label mal-text">{{ $t('select_wing') }}</label>
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <select class="form-control custom-select" v-model="upload_wing" @change="clearFiles">
                                        <option value="">{{ $t('select_wing') }}</option>
                                        <option value="1">{{ $t('wisdom') }}</option>
                                        <option value="2">{{ $t('youth') }}</option>
                                        <option value="3">{{ $t('students') }}</option>
                                        <option value="4">{{ $t('women') }}</option>
                                        <option value="6">{{ $t('girls') }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <!-- Existing Files Display -->
                        <div class="form-group basic" v-if="upload_wing && getExistingFiles(upload_wing).length > 0">
                            <label class="label mal-text">{{ $t('existing_files') }} ({{ getExistingFiles(upload_wing).length }})</label>
                            <div class="existing-files-list">
                                <div class="file-item existing-file" v-for="(file, index) in getExistingFiles(upload_wing)" :key="'existing-' + index">
                                    <div class="file-info">
                                        <ion-icon name="document-outline" v-if="!isImageFile({type: getFileType(file)})"></ion-icon>
                                        <ion-icon name="image-outline" v-if="isImageFile({type: getFileType(file)})"></ion-icon>
                                        <span class="file-name">{{ getFileName(file) }}</span>
                                        <small class="file-status text-success">{{ $t('uploaded') }}</small>
                                    </div>
                                    <div class="file-actions">
                                        <button type="button" class="btn btn-sm btn-outline-primary" @click="viewFile(file)">
                                            <ion-icon name="eye-outline"></ion-icon>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-outline-success" @click="downloadFile(file)">
                                            <ion-icon name="download-outline"></ion-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group basic" v-if="upload_wing">
                            <label class="label mal-text">
                                {{ getExistingFiles(upload_wing).length > 0
                                    ? $t('select_new_files_replace_old')
                                    : $t('select_minutes_files')
                                }}
                            </label>
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <input type="file" 
                                           class="form-control" 
                                           multiple 
                                           accept="image/*,.pdf,.doc,.docx" 
                                           @change="handleFileSelect" 
                                           ref="fileInput">
                                    <small class="form-text text-muted mal-text">
                                        {{ $t('allowed_file_types') }}
                                    </small>
                                </div>
                            </div>
                        </div>

                        <!-- Selected Files Preview -->
                        <div class="form-group basic" v-if="selected_files.length > 0">
                            <label class="label mal-text">{{ $t('selected_files') }} ({{ selected_files.length }})</label>
                            <div class="selected-files-list">
                                <div class="file-item" v-for="(file, index) in selected_files" :key="index">
                                    <div class="file-info">
                                        <ion-icon name="document-outline" v-if="!isImageFile(file)"></ion-icon>
                                        <ion-icon name="image-outline" v-if="isImageFile(file)"></ion-icon>
                                        <span class="file-name">{{ file.name }}</span>
                                        <small class="file-size">({{ formatFileSize(file.size) }})</small>
                                    </div>
                                    <button type="button" class="btn btn-sm btn-outline-danger" @click="removeFile(index)">
                                        <ion-icon name="trash-outline"></ion-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="form-group" v-if="upload_message">
                            <div class="error-feedback">
                                {{ upload_message }}
                            </div>
                        </div>

                        <div class="form-group basic" v-if="upload_wing">
                            <button type="button" @click="uploadElectionMinutes()" 
                                    class="btn btn-primary btn-block btn-lg" 
                                    :disabled="loading || selected_files.length === 0"
                                    v-if="selected_files.length > 0">
                                <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                <span>{{ loading ? $t('uploading_files') : (getExistingFiles(upload_wing).length > 0 ? $t('replace_files') : $t('upload_files')) }}</span>
                            </button>
                            <button type="button" class="btn btn-secondary btn-block btn-lg" 
                                    :class="{ 'mt-2': selected_files.length > 0 }"
                                    @click="closeElectionMinutesModel" :disabled="loading">
                                <span>{{ getExistingFiles(upload_wing).length > 0 && selected_files.length === 0 ? $t('close') : $t('cancel') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- * Election Minutes Upload Modal -->
    <div class="section pt-0 mt-0" v-if="this.wing != '5' && $route.params.sub_level != 1">
        <div class="wallet-card mt-1">
            <div class="wallet-footer wallet-footer-user">
                <div class="item">
                    <a href="javascript:void(0)">
                        <div class="row">
                            <strong class="add-member-btn col-12 text-center text-primary">
                                {{ $t('exc_members_count') }} <span>{{exc_count}}</span>
                            </strong>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="section-heading">
        <button type="button" class="btn btn-primary btn-sm me-1 mb-1" @click="countAdd"
            v-if="this.add_permission && this.wing != '5' && $route.params.sub_level != 1">
            <ion-icon name="add-outline"></ion-icon>
            {{ $t('exc_count') }}
        </button>
        <button type="button" class="btn btn-primary btn-sm me-1 mb-1" @click="adminAdd" v-if="this.add_permission">
            <ion-icon name="add-outline"></ion-icon>
            {{ $t('add') }}
        </button>
        <button type="button" class="btn btn-success btn-sm me-1 mb-1" @click="openElectionMinutesModal" v-if="this.add_permission">
            <ion-icon name="cloud-upload-outline"></ion-icon>
            {{ $t('election_minutes_upload') }}
        </button>
    </div>
    <div class="listview-title mt-0 mal-text custom-title">
        {{ $t('list') }}</div>
    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>
    <div class="section mt-2 mb-2">
        <div class="card">
            <h4 class="text-center mt-1 mal-text error-feedback" v-if="!loading_list && message">{{message}}</h4>
        </div>
    </div>
    <ul class="listview image-listview inset text" v-if="!loading_list">
        <li v-for="(admin_list,index) in admin_lists" v-bind:key="admin_list.id">
            <a href="javascript:void(0)" class="item">
                <span class="sl-no">{{(index+1)}}</span>
                <img src="assets/img/sample/avatar/avatar1.png" alt="image" class="image">
                <div class="in">
                    <div>
                        <header class="mal-text">{{admin_list.user_sublevel_desc}}</header>
                        <b>{{ admin_list.member?admin_list.member.name:'' }} </b>
                        <footer><span v-for="(department , index) in admin_list.departments" v-bind:key="department.id"
                                class="mal-text custom-title">{{department.name_mal}} {{index+1 ==
                                (admin_list.departments.length)?'':'|'}}</span>
                                <span v-if="admin_list.event_status"><br>{{admin_list.event_status_text}} : <b class="mal-text"
                                    v-bind:class="admin_list.event_status == 'Not Registered' ? 'text-danger' : 'text-success'">
                                    {{ admin_list.event_status }}</b></span></footer>
                    </div>
                    <!-- <a href="javascript:void(0)" @click="adminView(admin_list)" v-if="!admin_list.user_level_name">
                        <span class="badge badge-primary">
                            <ion-icon name="create-outline"></ion-icon>
                        </span>
                    </a> -->
                    <!-- Default Action Sheet Inset -->
                    <div class="card-button dropdown">
                        <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                            :data-bs-target="'#actionSheetInset'+admin_list.id" @click="showActionModel">
                            <ion-icon name="ellipsis-horizontal"></ion-icon>
                        </button>
                    </div>
                    <div class="modal fade action-sheet" :id="'actionSheetInset'+admin_list.id" tabindex="-1"
                        role="dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">{{ $t('action') }}</h5>
                                </div>
                                <div class="modal-body">
                                    <ul class="action-button-list">
                                        <li v-if="admin_list.member">
                                            <a :href="'tel:'+admin_list.member.mobile" class="btn btn-list">
                                                <span>
                                                    <ion-icon name="call-outline"></ion-icon> {{ $t('call') }}
                                                </span>
                                            </a>
                                        </li>
                                        
                                        <li v-if="admin_list.member?admin_list.member.whatsapp:false && admin_list.member">
                                            <a :href="'https://wa.me/'+admin_list.member.whatsapp_country_code+admin_list.member.whatsapp+'?text='"
                                            class="btn btn-list">
                                            <span>
                                                <ion-icon name="logo-whatsapp"></ion-icon> {{ $t('whatsapp') }}
                                            </span>
                                        </a>
                                        </li>
                                        <li v-if="(this.add_permission) && admin_list.member">
                                            <a href="javascript:void(0)" @click="adminView(admin_list)"
                                                class="btn btn-list" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="pencil-outline"></ion-icon> {{ $t('edit') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="(admin_list.councillor == 'N' && this.add_permission)">
                                            <a href="javascript:void(0)" @click="adminDeleteConfirmation(admin_list)"
                                                class="btn btn-list" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="trash-outline"></ion-icon> {{ $t('remove') }}
                                                </span>
                                            </a>
                                        </li>
                                        <li class="action-divider"></li>
                                        <li>
                                            <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="close-outline"></ion-icon> {{ $t('cancel') }}
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- * Default Action Sheet Inset -->
                </div>
            </a>
        </li>
    </ul>
    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import UserService from "../../services/user.service";
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import $ from 'jquery';
import AlertModel from "../layouts/AlertModel.vue";
import DialogModel from "../layouts/DialogModel.vue";
export default {
    name: 'Admin List',
    components: {
        Form,
        Field,
        ErrorMessage,
        vSelect,
        AlertModel,
        DialogModel
    },
    data() {
        // const nameRegex = /^[a-zA-Z0-9&._-\s]*$/g;
        const schema = yup.object().shape({
            wing: yup.string().required(this.$t('wing_required_field')),
            designation: yup.string().required(this.$t('designation_required')),
            // member: yup.string().required("Name is required!"),
        });
        return {
            loading: false,
            loading_list: false,
            message: "",
            wing: '',
            designation: '',
            state_designations: [
                { id: '1', value: 'President', value_mal: 'പ്രസിഡണ്ട്' },
                { id: '3', value: 'General Secretary', value_mal: 'ജനറൽ സെക്രെട്ടറി' },
                { id: '5', value: 'Treasurer', value_mal: 'ട്രെഷറർ' },
                { id: '2', value: 'Vice President', value_mal: 'വൈസ് പ്രസിഡണ്ട്' },
                { id: '4', value: 'Secretary', value_mal: 'സെക്രെട്ടറി' },
                { id: '6', value: 'Executive Member', value_mal: 'എക്സിക്യൂട്ടീവ് മെമ്പർ' },
                ],
                designations: [
                { id: '1', value: 'President', value_mal: 'പ്രസിഡണ്ട്' },
                { id: '3', value: 'Secretary', value_mal: 'സെക്രെട്ടറി' },
                { id: '5', value: 'Treasurer', value_mal: 'ട്രെഷറർ' },
                { id: '2', value: 'Vice President', value_mal: 'വൈസ് പ്രസിഡണ്ട്' },
                { id: '4', value: 'Joint Secretary', value_mal: 'ജോയിന്റ് സെക്രെട്ടറി' },
                { id: '6', value: 'Executive Member', value_mal: 'എക്സിക്യൂട്ടീവ് മെമ്പർ' },
                ],
                balavedi_designations: [
                { id: '1', value: 'Captain', value_mal: 'ക്യാപ്റ്റൻ' },
                { id: '3', value: 'Vice Captain', value_mal: 'വൈസ് ക്യാപ്റ്റൻ' },
                ],
            schema,
            user_level: "",
            admin_lists: [],
            editable_id: '',
            editable: true,
            add_admin: false,
            member_list: [],
            department_list: [],
            department: [],
            member: '',
            member_edit: true,
            report_permission: false,
            add_permission: false,
            unit: [],
            exc_count: 0,
            alert_type: '',
            alert_message: '',
            dialog_message: '',
            dialog_action: '',
            dialog_action_params: [],
            disable_member_form: false,
            // Election Minutes Upload
            upload_wing: '',
            selected_files: [],
            upload_message: '',
            election: null

        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        }
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.user_level = parseInt(this.$route.params.sub_level);
            this.getAdminList(1);
            if (this.user_level == this.currentUser.user_level) {
                this.editable = true;
            } else {
                this.editable = true;
            }
            this.$root.updateParent(this.$t('executive_members_list'));
        }

        window.onpopstate = function() {
            if ($('body').hasClass('modal-open')) {
                location.reload();
            }
        };
    },
    methods: {
        onSearch(search, loading, type) {
            if (search.length) {
                loading(true);
                this.getTextList(search, type);
            }
        },
        // Existing Files Management Methods
        getExistingFiles(wing) {
            if (!this.election) return [];
            
            const wingMap = {
                '1': 'wisdom_minutes',
                '2': 'youth_minutes', 
                '3': 'students_minutes',
                '4': 'women_minutes',
                '6': 'girls_minutes'
            };
            
            const fieldName = wingMap[wing];
            if (!fieldName || !this.election[fieldName]) return [];
            
            try {
                return JSON.parse(this.election[fieldName]);
            } catch (e) {
                console.error('Error parsing existing files:', e);
                return [];
            }
        },
        getFileName(filePath) {
            // Extract filename from full path
            const fileName = filePath.split('/').pop();
            // Clean up the filename for display
            const cleanName = fileName.replace(/^\d+_[a-f0-9]+_/, '').replace(/_/g, ' ');
            return cleanName || fileName;
        },
        getFileType(filePath) {
            const extension = filePath.split('.').pop().toLowerCase();
            const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
            const docTypes = ['pdf', 'doc', 'docx'];
            
            if (imageTypes.includes(extension)) {
                return 'image/' + extension;
            } else if (docTypes.includes(extension)) {
                return 'application/' + extension;
            }
            return 'application/octet-stream';
        },
        viewFile(filePath) {
            const fullUrl = 'https://guideportal.wisdomislam.org/' + filePath;
            window.open(fullUrl, '_blank');
        },
        downloadFile(filePath) {
            const fullUrl = 'https://guideportal.wisdomislam.org/' + filePath;
            const link = document.createElement('a');
            link.href = fullUrl;
            link.setAttribute('download', this.getFileName(filePath));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        refreshElectionData() {
            // Method to refresh election data after file operations
            // This should be called to get updated file lists from server
            const data = {
                sub_level_type: this.user_level,
                sub_level_id: parseInt(this.$route.params.id)
            };
            
            UserService.authPostRequest('get-election-schedule', data).then(
                (response) => {
                    if (response.data.status == 'success' && response.data.data.list) {
                        this.election = response.data.data.list;
                    }
                },
                (error) => {
                    console.error('Error refreshing election data:', error);
                }
            );
        },
        getTextList(event, type) {
            if (type == '4') {
                type = '11';
            }
            if (type == '6') {
                type = '10';
            }
            this.message = '';
            let data = {
                q: event,
                type: type,
                filter: 'inside',
                user_level_id: this.$route.params.id,
                user_level: this.user_level
            }
            UserService.authPostRequest('get-typehead-values', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.member_list = response.data.data.list;
                        this.loading_list = false;
                    } else {
                        this.loading_list = true;
                    }
                },
                (error) => {
                    this.loading_list = true;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getDepartments(wing, clear_member = false) {
            let data = {
                wing: wing,
                user_level: this.user_level,
                level_id: this.$route.params.id
            }
            if (clear_member) {
                this.member = '';
                this.member_list = [];
                this.member_edit = true;
            }

            UserService.authPostRequest('get-departments', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.department_list = response.data.data.list;
                        this.loading_list = false;
                    } else {
                        this.loading_list = true;
                    }
                },
                (error) => {
                    this.loading_list = true;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getAdminList(wing) {
            this.wing = wing.toString();
            this.loading_list = true;
            let data = {
                sub_level_type: this.user_level,
                id: this.user_level == 1 ? null : parseInt(this.$route.params.id),
                wing: wing
            }
            UserService.getAdminList('get-excecutive-list', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.admin_lists = response.data.data.list;
                        this.report_permission = response.data.data.report_permission;
                        this.add_permission = response.data.data.add_permission;
                        this.unit = response.data.data.unit;
                        this.election = response.data.data.election;
                        if (response.data.data.unit) {
                            if (this.wing == '1') {
                                this.exc_count = response.data.data.unit.wisdom_executives_count;
                            } else if (this.wing == '2') {
                                this.exc_count = response.data.data.unit.youth_executives_count;
                            } else if (this.wing == '3') {
                                this.exc_count = response.data.data.unit.students_executives_count;
                            } else if (this.wing == '4') {
                                this.exc_count = response.data.data.unit.women_executives_count;
                            } else if (this.wing == '5') {
                                this.exc_count = response.data.data.unit.balavedi_executives_count;
                            } else if (this.wing == '6') {
                                this.exc_count = response.data.data.unit.gilrs_executives_count;
                            } else {
                                this.exc_count = 0;
                            }
                        }

                        this.message = response.data.message;
                        this.loading_list = false;
                    } else if (response.data.status == 'warning') {
                        // $('#excCountModel').modal('hide');
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        adminView(admin) {
            $('#addAdminModel').modal('show');
            this.message = '';
            this.wing = admin.wing;
            this.getTextList(admin.member.name, this.wing);
            this.getDepartments(admin.wing);
            if (admin.councillor != 'N') {
                this.disable_member_form = true;
            } else {
                this.disable_member_form = false;
            }
            this.member = {
                id: admin.member_id,
                member_id: admin.member_id,
                text: admin.member.name,
                mobile: admin.member.mobile,
                country_code: admin.member.country_code
            }
            this.member_edit = false;
            this.member_list.push(this.member);
            this.designation = admin.designation;
            if (admin.departments) {
                let item = [];
                admin.departments.forEach(element => {
                    let item_ = { id: element.pivot.department_id, text: element.name_mal }
                    item.push(item_);
                });
                this.department = item;
            }
            this.editable_id = admin.id;
            this.add_admin = false;
        },
        adminAdd() {
            if (this.exc_count <= 0) {
                this.$swal.fire(
                    '',
                    'എക്സിക്യൂട്ടീവ് അംഗങ്ങളുടെ എണ്ണം അപ്ഡേറ്റ് ചെയ്തിട്ടില്ല. അതിനു ശേഷം അംഗങ്ങളെ ചേർക്കൽ തുടങ്ങുക.'
                ).then((result) => {
                    if (result.isConfirmed) {
                        $('#excCountModel').modal('show');

                    }
                });

            } else {
                this.disable_member_form = false;
                $('#addAdminModel').modal('show');
                this.getDepartments(this.wing);
                this.message = '';
                this.designation = '';
                this.member_edit = true;
                this.member = '';
                this.department = [];
                this.editable_id = null;
                this.add_admin = true;
            }
        },
        countAdd() {
            $('#excCountModel').modal('show');
            this.message = '';
        },
        addAdmin(user) {
            user.id = this.editable_id;
            user.user_level = this.user_level;
            user.added_by = this.currentUser.id;

            if (!this.member) {
                this.message = 'ദയവായി മെമ്പറെ ലിസ്റ്റിൽ നിന്നും സെലക്ട് ചെയ്തതിനു ശേഷം Save അമർത്തുക';
            }

            user.member = {
                id: this.member.member_id?this.member.member_id:this.member.id,
                name: this.member.name,
            }

            user.department = JSON.stringify(this.department);
            if (user.user_level == 2) {
                user.district_id = parseInt(this.$route.params.id);
            }
            if (user.user_level == 3) {
                user.district_id = this.currentUser.district_id;
                user.zone_id = parseInt(this.$route.params.id);
            }
            if (user.user_level == 4) {
                user.district_id = this.currentUser.district_id;
                user.zone_id = this.currentUser.zone_id;
                user.unit_id = parseInt(this.$route.params.id);
            }

            this.loading = true;
            UserService.addAdmin('store-excecutive-member', user).then(
                (response) => {
                    if (response.data.status == 'success') {
                        $('#addAdminModel').modal('hide')
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.getAdminList(user.wing);
                        this.loading = false;
                        this.message = '';
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;

                    this.messafe = (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        countSave() {
            let user = {};
            user.id = this.editable_id;
            user.wing = this.wing;
            user.exc_count = this.exc_count;
            user.user_level = this.user_level;
            user.added_by = this.currentUser.id;
            if (user.user_level == 2) {
                user.district_id = parseInt(this.$route.params.id);
            }
            if (user.user_level == 3) {
                user.district_id = this.currentUser.district_id;
                user.zone_id = parseInt(this.$route.params.id);
            }
            if (user.user_level == 4) {
                user.district_id = this.currentUser.district_id;
                user.zone_id = this.currentUser.zone_id;
                user.unit_id = parseInt(this.$route.params.id);
            }
            this.loading = true;
            UserService.addAdmin('set-excecutive-count', user).then(
                (response) => {
                    if (response.data.status == 'success') {
                        $('#excCountModel').modal('hide');
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.messafe = (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );

        },
        adminDeleteConfirmation(admin_list) {
            var data = {
                id: admin_list.id,
                wing: admin_list.wing,
                user_level: this.user_level
            }
            this.dialog_action_params = data;
            this.dialog_message = 'ശരിക്കും ഡിലീറ്റ് ചെയ്യണോ?';
            this.dialog_action = 'adminDelete';
            this.$refs.dialog_model.openModel();
            this.loading = false;
        },
        adminDelete(data) {
            UserService.authPostRequest('delete-excecutive-member', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.getAdminList(data.wing);
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        closeAddAdminModel() {
            $('#addAdminModel').modal('hide');
        },
        editBtn() {
            this.member_edit = true;
        },
        // Election Minutes Upload Methods
        openElectionMinutesModal() {
            // Set the current wing as default selection
            this.upload_wing = this.wing;
            this.selected_files = [];
            this.upload_message = '';
            // Load election data if not already loaded
            if (!this.election) {
                this.refreshElectionData();
            }
            $('#electionMinutesModel').modal('show');
        },
        closeElectionMinutesModel() {
            this.upload_wing = '';
            this.selected_files = [];
            this.upload_message = '';
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = '';
            }
            $('#electionMinutesModel').modal('hide');
        },
        handleFileSelect(event) {
            const files = Array.from(event.target.files);
            
            // Validate file size (max 10MB per file)
            const maxSize = 10 * 1024 * 1024; // 10MB
            const validFiles = files.filter(file => {
                if (file.size > maxSize) {
                    this.upload_message = `${file.name} is too large. Maximum file size is 10MB.`;
                    return false;
                }
                return true;
            });
            
            this.selected_files = validFiles;
            this.upload_message = '';
        },
        removeFile(index) {
            this.selected_files.splice(index, 1);
            if (this.selected_files.length === 0 && this.$refs.fileInput) {
                this.$refs.fileInput.value = '';
            }
        },
        clearFiles() {
            this.selected_files = [];
            this.upload_message = '';
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = '';
            }
        },
        isImageFile(file) {
            return file.type.startsWith('image/');
        },
        formatFileSize(bytes) {
            if (bytes === 0) return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        },
        uploadElectionMinutes() {
            if (!this.upload_wing) {
                this.upload_message = 'ദയവായി വിങ് സെലക്ട് ചെയ്യുക';
                return;
            }
            
            if (this.selected_files.length === 0) {
                this.upload_message = 'ദയവായി മിനിറ്റ്സ് ഫയലുകൾ സെലക്ട് ചെയ്യുക';
                return;
            }
            
            this.loading = true;
            this.upload_message = '';
            
            const formData = new FormData();
            
            // Add files to FormData
            this.selected_files.forEach((file) => {
                formData.append('files[]', file);
            });
            
            // Add other data
            formData.append('wing', this.upload_wing);
            formData.append('user_level', this.user_level);
            formData.append('uploaded_by', this.currentUser.id);
            
            // Add level-specific IDs
            if (this.user_level == 2) {
                formData.append('district_id', parseInt(this.$route.params.id));
            } else if (this.user_level == 3) {
                formData.append('district_id', this.currentUser.district_id);
                formData.append('zone_id', parseInt(this.$route.params.id));
            } else if (this.user_level == 4) {
                formData.append('district_id', this.currentUser.district_id);
                formData.append('zone_id', this.currentUser.zone_id);
                formData.append('unit_id', parseInt(this.$route.params.id));
            }
            
            UserService.authPostRequest('upload-excecutive-minutes', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.closeElectionMinutesModel();
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        // Refresh election data to show newly uploaded files
                        this.refreshElectionData();
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'error') {
                        this.upload_message = response.data.message;
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.upload_message = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        }

    },
};
</script>

<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
    margin-bottom: 0px;
}

.error-feedback {
    color: red;
}

.edit-btn {
    margin-top: 24px;
}

.action-button-list>li {
    min-height: 1px !important;
}

.typehead-div {
    /* margin-left: -3% !important; */
}

.d-center {
    display: flex;
    align-items: center;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.selected img {
    width: auto;
    max-height: 23px;
    margin-right: 0.5rem;
}

.v-select .dropdown li {
    border-bottom: 1px solid rgba(112, 128, 144, 0.1);
}

.v-select .dropdown li:last-child {
    border-bottom: none;
}

.v-select .dropdown li a {
    padding: 10px 20px;
    width: 100%;
    font-size: 1.25em;
    color: #3c3c3c;
}

.v-select .dropdown-menu .active>a {
    color: #fff;
}

.add-member-btn {
    font-size: 16px !important;
    font-weight: 800 !important;
}

/* Election Minutes Upload Styles */
.selected-files-list {
    max-height: 300px;
    overflow-y: auto;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 10px;
    background-color: #f8f9fa;
}

.section-heading .btn {
    height: 40px;
}

.section-heading .btn ion-icon {
    font-size: 20px;
    margin-right: 6px;
}

.file-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    margin-bottom: 8px;
    background-color: white;
    border-radius: 6px;
    border: 1px solid #e9ecef;
}

.file-info {
    display: flex;
    align-items: center;
    flex: 1;
}

.file-info ion-icon {
    margin-right: 8px;
    font-size: 18px;
    color: #6c757d;
}

.file-name {
    font-weight: 500;
    margin-right: 8px;
    word-break: break-word;
}

.file-size {
    color: #6c757d;
    font-size: 12px;
}

.btn-outline-danger {
    border-color: #dc3545;
    color: #dc3545;
}

.btn-outline-danger:hover {
    background-color: #dc3545;
    border-color: #dc3545;
    color: white;
}

.form-text.text-muted {
    font-size: 12px;
    margin-top: 5px;
    color: #6c757d !important;
}

/* Existing Files Styles */
.existing-files-list {
    max-height: 250px;
    overflow-y: auto;
    border: 1px solid #28a745;
    border-radius: 8px;
    padding: 10px;
    background-color: #f8fff9;
    margin-bottom: 15px;
}

.existing-file {
    background-color: #e8f5e8 !important;
    border-color: #28a745 !important;
}

.existing-file .file-info ion-icon {
    color: #28a745 !important;
}

.existing-file .file-name {
    color: #155724;
    font-weight: 600;
}

.file-status {
    font-style: italic;
    font-size: 11px !important;
    margin-left: 5px;
}

.file-actions {
    display: flex;
    gap: 5px;
    align-items: center;
}

.file-actions .btn {
    padding: 2px 6px;
    min-width: auto;
}

.file-actions .btn ion-icon {
    font-size: 14px;
}

.btn-outline-primary {
    border-color: #007bff;
    color: #007bff;
}

.btn-outline-primary:hover {
    background-color: #007bff;
    border-color: #007bff;
    color: white;
}

.btn-outline-success {
    border-color: #28a745;
    color: #28a745;
}

.btn-outline-success:hover {
    background-color: #28a745;
    border-color: #28a745;
    color: white;
}

/* Different styling for selected files vs existing files */
.selected-files-list .file-item {
    background-color: #fff3cd;
    border-color: #ffc107;
}

.selected-files-list .file-info ion-icon {
    color: #856404;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .file-actions {
        flex-direction: column;
        gap: 2px;
    }
    
    .file-actions .btn {
        font-size: 12px;
        padding: 1px 4px;
    }
    
    .file-name {
        font-size: 13px;
        word-break: break-all;
    }
}
</style>